import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Search } from "lucide-react";
import { Dialog, DialogContent, DialogTitle } from "@/components/ui/dialog";
import { api, formatPrice } from "@/lib/api";
import { t } from "@/lib/i18n";

export const SearchOverlay = ({ open, onOpenChange }) => {
  const [q, setQ] = useState("");
  const [results, setResults] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    if (q.trim().length < 2) { setResults([]); return; }
    let stale = false;
    const id = setTimeout(() => api.get("/products", { params: { q, limit: 6 } }).then((r) => { if (!stale) setResults(r.data); }).catch(() => setResults([])), 250);
    return () => { stale = true; clearTimeout(id); };
  }, [q]);

  const go = (path) => { onOpenChange(false); setQ(""); navigate(path); };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="bg-[#F5F0E8] max-w-2xl top-[12%] translate-y-0 p-0 gap-0 rounded-none" data-testid="search-overlay">
        <DialogTitle className="sr-only">{t("search")}</DialogTitle>
        <form onSubmit={(e) => { e.preventDefault(); if (q.trim()) go(`/collezione?q=${encodeURIComponent(q.trim())}`); }} className="flex items-center gap-3 px-5 border-b border-[#D5B98C]/50">
          <Search className="w-5 h-5 text-[#956842]" strokeWidth={1.5} />
          <input
            autoFocus
            data-testid="search-input"
            value={q}
            onChange={(e) => setQ(e.target.value)}
            placeholder={t("searchPlaceholder")}
            className="flex-1 h-16 bg-transparent outline-none font-serif text-xl placeholder:text-[#242321]/40"
          />
        </form>
        <div className="max-h-[60vh] overflow-y-auto">
          {results.map((p) => (
            <button key={p.slug} data-testid={`search-result-${p.slug}`} onClick={() => go(`/prodotto/${p.slug}`)} className="w-full flex items-center gap-4 px-5 py-3 text-left hover:bg-[#D5B98C]/20 transition-colors">
              <img src={p.images[0]} alt={p.name} className="w-12 h-16 object-cover" />
              <div className="flex-1">
                <div className="font-serif text-lg text-[#39251D]">{p.name}</div>
                <div className="text-xs text-[#956842] uppercase tracking-widest">{p.category_name}</div>
              </div>
              <div className="text-sm">{formatPrice(p.sale_price ?? p.price)}</div>
            </button>
          ))}
          {q.trim().length >= 2 && results.length === 0 && (
            <p data-testid="search-no-results" className="px-5 py-6 text-sm text-[#242321]/60">Nessun risultato per “{q}”.</p>
          )}
        </div>
      </DialogContent>
    </Dialog>
  );
};
